import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMicrophone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	stroke: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
	})
});
export default SvgMicrophone;
